import { PortalProducts } from '~/analytics/types/analytics.type'

import AnalyticsEvents_V2 from '../analyticsGA4'

import { FormEvents, FormNames } from './formEvents.types'
class FormAnalytics extends AnalyticsEvents_V2 {
  private formName: string
  public constructor(category: PortalProducts, form: FormNames) {
    super(category)
    this.formName = form
  }

  public writingInForms(field: string, param = {}, formName = this.formName): void {
    this.logEvent({
      event: FormEvents.WRITING_IN_FORM,
      title: `${formName}:${field}`,
      form: formName,
      ...param,
    })
  }

  public changeInSelectOption(field: string, param = {}, formName = this.formName): void {
    this.logEvent({
      event: FormEvents.CHANGE_FORM_FIELD,
      title: `${formName}:${field}`,
      form: formName,
      ...param,
    })
  }
}

export default FormAnalytics
